import React, { useState } from 'react';
import { Paperclip, Image, FileText, ExternalLink, X } from 'lucide-react';
import { Dialog, DialogContent } from '@/components/ui/dialog';

function isImage(filename) {
  return /\.(png|jpg|jpeg|gif|webp|svg|bmp)$/i.test(filename);
}

export default function FeedbackAttachments({ attachments = [] }) {
  const [previewUrl, setPreviewUrl] = useState(null);

  if (!attachments || attachments.length === 0) return null;

  return (
    <>
      <div className="mt-3">
        <span className="text-slate-500 font-medium text-xs">Attachments:</span>
        <div className="flex flex-wrap gap-2 mt-1.5">
          {attachments.map((att, idx) => (
            isImage(att.filename || '') ? (
              <button
                key={idx}
                onClick={() => setPreviewUrl(att.url)}
                className="group relative w-20 h-20 rounded-md overflow-hidden border border-slate-700 hover:border-indigo-500 transition-colors"
              >
                <img src={att.url} alt={att.filename} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <ExternalLink className="w-4 h-4 text-white" />
                </div>
              </button>
            ) : (
              <a
                key={idx}
                href={att.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-2.5 py-1.5 bg-slate-800 border border-slate-700 rounded-md hover:border-indigo-500 transition-colors text-xs text-slate-300"
              >
                <FileText className="w-3.5 h-3.5 text-slate-400" />
                <span className="truncate max-w-[120px]">{att.filename}</span>
                <ExternalLink className="w-3 h-3 text-slate-500" />
              </a>
            )
          ))}
        </div>
      </div>

      <Dialog open={!!previewUrl} onOpenChange={() => setPreviewUrl(null)}>
        <DialogContent data-testid="fb-feedbackattachments-dialog" className="max-w-3xl bg-slate-900 border-slate-700 p-2">
          <button
            onClick={() => setPreviewUrl(null)}
            className="absolute top-2 right-2 p-1 rounded bg-slate-800 hover:bg-slate-700 text-slate-400 z-10"
          >
            <X className="w-4 h-4" />
          </button>
          {previewUrl && (
            <img src={previewUrl} alt="Preview" className="w-full h-auto rounded" />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}